import { Routes } from '@angular/router';
import { SiaPdfSessionViewerComponent } from './pages/sia-pdf-session-viewer/sia-pdf-session-viewer.component';
import { SiaPortalDocumentViewerComponent } from './pages/sia-portal-document-viewer/sia-portal-document-viewer.component';
import { SiaResourceDocumentViewerComponent } from './pages/sia-resources-document-viewer/sia-resources-document-viewer.component';

export const ROUTES: Routes = [
  {
    path: 'pdf/:pdfName/:guid',
    component: SiaPortalDocumentViewerComponent,
  },
  {
    path: 'pdf-resource/:pdfName/:guid',
    component: SiaResourceDocumentViewerComponent,
  },
  {
    path: 'pdf-viewer/:guid',
    component: SiaPdfSessionViewerComponent,
  },
];
